<template>
  <div class="flex flex-col md:flex-row justify-between items-start gap-4">
    <div class="space-y-4 flex-1">
      <Button variant="ghost" size="sm" class="-ml-2 text-muted-foreground" @click="$emit('back')">
        <ArrowLeft class="w-4 h-4 mr-2" /> Retour à la liste
      </Button>
      
      <div class="space-y-2">
        <div class="flex flex-wrap items-center gap-3">
          <h1 class="text-3xl font-bold tracking-tight text-foreground">{{ investment.name }}</h1>
          <div class="flex gap-2">
            <Badge v-if="investment.ignoreInGlobalSums && !investment.isSimulation" variant="destructive" class="bg-amber-500/10 text-amber-500 hover:bg-amber-500/20 border-amber-500/20 px-3">
              Exclue du calcul global
            </Badge>
            <Badge v-if="investment.isSimulation" class="bg-purple-500/10 text-purple-500 hover:bg-purple-500/20 border-purple-500/20 px-3 flex items-center gap-1.5">
              <Beaker class="w-3.5 h-3.5" /> Simulation
            </Badge>
            <Badge v-if="investment.ignorePnL" variant="secondary" class="bg-amber-500/10 text-amber-500 hover:bg-amber-500/20 border-amber-500/20 px-3">
              P&L Exclue
            </Badge>
            <Badge v-if="investment.category" variant="outline" class="bg-muted border-border px-3 text-foreground">
              {{ investment.category.name }}
            </Badge>
          </div>
        </div>
        <p class="text-lg text-muted-foreground max-w-3xl leading-relaxed">{{ investment.description }}</p>
      </div>

      <div class="flex flex-wrap items-center gap-4 pt-2">
        <a v-if="investment.url" :href="investment.url" target="_blank" rel="noopener" 
           class="inline-flex items-center text-sm font-medium text-primary hover:underline transition-all">
          <ExternalLink class="w-4 h-4 mr-2" /> Visiter le site du placement
        </a>
        <div v-if="investment.comment" class="flex items-start gap-3 p-4 bg-muted border border-border rounded-lg max-w-2xl text-sm text-foreground italic">
          <StickyNote class="w-5 h-5 text-muted-foreground shrink-0 mt-0.5" />
          <p>{{ investment.comment }}</p>
        </div>
      </div>
    </div>

    <div class="flex gap-2">
      <Button variant="outline" @click="$emit('edit')">
        <Settings2 class="w-4 h-4 mr-2" /> Modifier le placement
      </Button>
    </div>
  </div>
</template>

<script setup>
import { ArrowLeft, ExternalLink, StickyNote, Settings2, Beaker } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'

defineProps({
  investment: { type: Object, required: true }
})

defineEmits(['back', 'edit'])
</script>
